import { ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'
import Styles from './AnimateSlideInOut.module.scss'
import { CSSTransitionProps } from 'react-transition-group/CSSTransition'

interface Props extends Pick<CSSTransitionProps<HTMLElement>, 'onExited' | 'timeout'> {
  in: boolean
  children: ReactNode
  direction?: 'up' | 'left'
}

const AnimateSlideInOut = (props: Props) => {
  const { direction = 'left', onExited, timeout = 300 } = props
  return (
    <CSSTransition
      in={props.in}
      timeout={timeout}
      unmountOnExit
      appear
      classNames={{
        enter: Styles[`${direction}SlideIn`],
        enterActive: Styles[`${direction}SlideInActive`],
        exit: Styles[`${direction}SlideOut`],
        exitActive: Styles[`${direction}SlideOutActive`],
      }}
      onExited={onExited}
    >
      {props.children}
    </CSSTransition>
  )
}

export { AnimateSlideInOut }
